const eventValueMapping = {
  fuelTypeGroup: {
    ele: 'electric',
    gsl: 'gasoline',
    hyb: 'hybrid',
    pih: 'plug-in-hybrid',
    dsl: 'diesel',
    hyd: 'hydrogen'
  },
  transmissionCode: {
    aut: 'automatic',
    man: 'manual'
  },
  engineCode: {
    '3cldr': '3-cylinders',
    '4cldr': '4-cylinders',
    '5cldr': '5-cylinders',
    '6cldr': '6-cylinders',
    '8cldr': '8-cylinders',
    '10cldr': '10-cylinders',
    '12cldr': '12-cylinders',
    '16cldr': '16-cylinders',
    rtr: 'rotary-engine'
  },
  dealType: {
    goodprice: 'good-price',
    greatprice: 'great-price'
  },
  sellerType: {
    d: 'dealer',
    p: 'private-seller'
  }
};
const pixallEventValueTransformer = (filterName, eventValue) => {
  const eventGroup = eventValueMapping[filterName];
  return eventGroup ? eventGroup[eventValue] || eventValue : eventValue;
};
export default pixallEventValueTransformer;